/**
 * Evidence API - Complete implementation matching trace-api.alpyne.ai/docs
 */

import { getAPIClient } from './client';

export interface Evidence {
  id: string;
  artifact_id: string;
  chunk_id: string | null;
  evidence_type: string;
  content?: string | null;  // Content from linked chunk (may be null if no chunk)
  page_number?: number;
  bbox?: { x: number; y: number; width: number; height: number };
  table_id?: string;
  figure_id?: string;
  content_hash: string;
  meta?: Record<string, any>;
  created_at: string;
}

export interface EvidenceTrace {
  evidence: Evidence;
  chunk: {
    id: string;
    content: string;
    strategy: string;
    position: number;
  };
  artifact: {
    id: string;
    filename: string;
    artifact_type: string;
    sha256: string;
    file_size_bytes: number;
    created_at: string;
  };
  source?: {
    type: string;
    description?: string;
  };
}

// Get evidence by ID
export async function getEvidence(evidenceId: string): Promise<Evidence> {
  const client = getAPIClient();
  return client.get<Evidence>(`/evidence/${evidenceId}`);
}

// Trace evidence to source
export async function traceEvidence(evidenceId: string): Promise<EvidenceTrace> {
  const client = getAPIClient();
  return client.get<EvidenceTrace>(`/evidence/${evidenceId}/trace`);
}

// List evidence
export async function listEvidence(
  projectId: string,
  artifactId?: string,
  limit: number = 100
): Promise<Evidence[]> {
  const client = getAPIClient();
  return client.get<Evidence[]>('/evidence', {
    params: {
      project_id: projectId,
      artifact_id: artifactId,
      limit,
    },
  });
}

// Get evidence with full content by hash
export async function getEvidenceByHash(contentHash: string): Promise<Evidence> {
  const client = getAPIClient();
  return client.get<Evidence>(`/evidence/by-hash/${contentHash}`);
}

